import type { AbuseScenarioStructured } from '../types/watchdog';

const LIKELIHOOD_LABELS: Record<string, string> = {
  low: 'nizka',
  medium: 'stredni',
  high: 'vysoka',
};

const EVIDENCE_LABELS: Record<string, string> = {
  direct_textual: 'prima textova opora',
  institutional_inference: 'institucionalni inference',
  hypothetical_abuse: 'hypoteticky scenar',
  uncertainty: 'nejistota',
};

interface Props {
  scenario: AbuseScenarioStructured;
}

export function AbuseScenarioCard({ scenario }: Props) {
  const alertNo = scenario.realistic_likelihood === 'low' || scenario.realistic_likelihood === 'medium';

  const scrollToProvision = (sectionId: string) => {
    const el = document.getElementById(`provision-${sectionId.replace(/\s+/g, '-')}`);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      el.classList.add('highlighted');
      setTimeout(() => el.classList.remove('highlighted'), 2000);
    }
  };

  return (
    <div className="abuse-scenario-card">
      <div className="abuse-scenario-card__header">
        <h5 className="abuse-scenario-card__title">{scenario.scenario_title}</h5>
        <div className="abuse-scenario-card__badges" aria-label="Parametry scenare">
          <span className={`abuse-scenario-card__likelihood abuse-scenario-card__likelihood--${scenario.realistic_likelihood}`}>
            pravdepodobnost: {LIKELIHOOD_LABELS[scenario.realistic_likelihood] ?? scenario.realistic_likelihood}
          </span>
          {scenario.evidence_type && (
            <span className={`abuse-scenario-card__evidence-type abuse-scenario-card__evidence-type--${scenario.evidence_type}`}>
              {EVIDENCE_LABELS[scenario.evidence_type] ?? scenario.evidence_type}
            </span>
          )}
          {alertNo && <span className="abuse-scenario-card__alert-no">alert: ne</span>}
        </div>
      </div>

      <div className="abuse-scenario-card__actors">
        <span className="abuse-scenario-card__actor">{scenario.who_could_misuse}</span>
        <span className="abuse-scenario-card__arrow">-&gt;</span>
        <span className="abuse-scenario-card__target">{scenario.against_whom}</span>
      </div>

      {scenario.affected_sections && scenario.affected_sections.length > 0 && (
        <div className="abuse-scenario-card__sections">
          {scenario.affected_sections.map((s) => (
            <button key={s} className="abuse-scenario-card__chip" onClick={() => scrollToProvision(s)}>
              {s}
            </button>
          ))}
        </div>
      )}

      {scenario.textual_evidence && (
        <blockquote className="abuse-scenario-card__evidence">{scenario.textual_evidence}</blockquote>
      )}

      <dl className="abuse-scenario-card__details">
        <dt>Mechanismus</dt>
        <dd>{scenario.mechanism}</dd>
        <dt>Co by se muselo stat</dt>
        <dd>{scenario.trigger_conditions}</dd>
        <dt>Proc to neni jen teorie</dt>
        <dd>{scenario.why_not_just_theoretical}</dd>
        <dt>Co by tomu branilo</dt>
        <dd className="abuse-scenario-card__safeguard">{scenario.what_would_block_it}</dd>
      </dl>
    </div>
  );
}
